import React from "react";

import CarrinhoModel from "./model/CarrinhoModel";
import CarrinhoItemModel from "./model/CarrinhoItemModel";
import CarrinhoItem from "./components/CarrinhoItem";
import AppState from "./model/AppState";
import LojaModel from "./model/LojaModel";
import ModalProdutoAlternativo from "./components/ModalProdutoAlternativo";
import { Snackbar } from "@material-ui/core";
import C5CarrinhoDAO from "./dataAccess/C5/C5CarrinhoDAO";
import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import Rodape from "./components/Rodape";
import NavegadorUtil from "./util/NavegadorUtil";
import Carregando from "./components/Carregando";
import C5PagamentoDAO from "./dataAccess/C5/C5PagamentoDAO";
import C5FreteModel from "./model/C5FreteModel";
import UsuarioModel from "./model/UsuarioModel";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";
import ProxyDistanciaDAO from "./dataAccess/Proxy/ProxyDistanciaDAO";
import C5LojaDAO from "./dataAccess/C5/C5LojaDAO";
import { getDistance } from "geolib";
import LocalizacaoModel from "./model/LocalizacaoModel";
import LojaDistanciaModel from "./model/LojaDistanciaModel";
import C5UsuarioDAO from "./dataAccess/C5/C5UsuarioDAO";
import UsuarioEnderecoModel from "./model/UsuarioEnderecoModel";
import DataUtil from "./util/DataUtil";
import ProdutoModel from "./model/ProdutoModel";
import ProxyCacheDAO from "./dataAccess/Proxy/ProxyCacheDados";
import ModalExclusaoCarrinho from "./components/ModalExclusaoCarrinho";
import ProxyPromocaoDAO from "./dataAccess/Proxy/ProxyPromocaoDAO";
import { ObaTipoPromocaoEnum } from "./model/ObaPromocaoModel";

type CarrinhoState = {
  showModalProdutoAlternativo: boolean;
  showModalExcluirCarrinho: boolean;
  carregando: boolean;
  concluido: boolean;
  deliveryDisponivel: boolean;
  retiradaDisponivel: boolean;
  fretes: C5FreteModel[];
  lojas: LojaModel[];
  descontoExtra: number;
};

interface ICarrinhoProps extends RouteComponentProps {}

export class Carrinho extends React.Component<ICarrinhoProps, CarrinhoState> {
  msgCarrinhoNecessidadeMaioridade = "Existem produtos no carrinho destacados em vermelho com a necessidade de confirmação de maioridade.";

  constructor(props: ICarrinhoProps) {
    super(props);

    this.toggleModalProdutoAlternativo = this.toggleModalProdutoAlternativo.bind(this);
    this.saveProdutoAlternativo = this.saveProdutoAlternativo.bind(this);
    this.setRetirada = this.setRetirada.bind(this);
    this.setDelivery = this.setDelivery.bind(this);
    this.alertaDeliveryInativo = this.alertaDeliveryInativo.bind(this);
    this.goHome = this.goHome.bind(this);
    this.excluirCarrinho = this.excluirCarrinho.bind(this);
    this.hideModalExcluirCarrinho = this.hideModalExcluirCarrinho.bind(this);
    this.excluirTodosProdutosCarrinho = this.excluirTodosProdutosCarrinho.bind(this);
    this.updateDeliveryDisponivel = this.updateDeliveryDisponivel.bind(this);
    this.render = this.render.bind(this);

    this.state = {
      showModalProdutoAlternativo: false,
      showModalExcluirCarrinho: false,
      carregando: true,
      concluido: false,
      retiradaDisponivel: false,
      deliveryDisponivel: false,
      fretes: [],
      lojas: [],
      descontoExtra: 0,
    };
  }

  async updateDeliveryDisponivel(): Promise<void> {
    const loja: LojaModel | null = AppState.getLojaSelecionada();
    let carrinho = AppState.getCarrinho();
    let { fretes } = this.state;

    if (loja && carrinho && fretes) {
      C5PagamentoDAO.getInstance()
      .getFrete(loja.cepDelivery, carrinho)
      .then((fretesE: C5FreteModel[]) => {
        if (fretesE.some((f) => f.tipoEntrega === "E")) {
          this.setState({ deliveryDisponivel: true });
        }
        fretes = fretes.concat(
          fretesE.filter((f) => f.tipoEntrega === "E")
        );
        this.setState({ carregando: false, concluido: true, fretes });
      })
      .catch(() => {
        this.setState({ carregando: false, concluido: true, fretes });
      });
    }
  }

  async componentDidMount(): Promise<void> {
    LogUtil.logPage("Carrinho");

    const loja: LojaModel | null = AppState.getLojaSelecionada();
    let usuario: UsuarioModel | null = AppState.getUsuarioLogado();
    let fretes: C5FreteModel[] = [];

    this.setState({ carregando: true });

    if (loja) {
      C5CarrinhoDAO.getInstance()
        .updateCarrinho(loja)
        .then((msgRemovidos) => {
          if (msgRemovidos && msgRemovidos.length > 0) {
            NavegadorUtil.alerta(this, msgRemovidos);
          }
          
          const carrinho: CarrinhoModel = AppState.getCarrinho();

          C5PagamentoDAO.getInstance()
            .getFrete(loja.cepDelivery, carrinho)
            .then(async (fretesR: C5FreteModel[]) => {
              if (fretesR.some((f) => f.tipoEntrega === "R")) {
                this.setState({ retiradaDisponivel: true });
              }
              fretes = fretes.concat(
                fretesR.filter((f) => f.tipoEntrega === "R")
              );

              if (!usuario) {
                NavegadorUtil.alerta(
                  this,
                  `Faça login para confirmar se esta loja realiza entregas para seu endereço.`
                );
                this.setState({ carregando: false, concluido: true });
              } else {
                const usuarioEndereco: UsuarioEnderecoModel | null = await C5UsuarioDAO.getInstance().buscaUsuarioEnderecoCompleto(+usuario.clienteId);
                const usuarioEnderecoId: number | null = await C5UsuarioDAO.getInstance().buscaUsuarioEndereco(+usuario.clienteId);
                
                if (usuarioEndereco && usuarioEnderecoId) {

                  usuario.clienteEnderecoId = usuarioEnderecoId;
                  AppState.setUsuarioLogado(usuario);

                  if (!usuarioEndereco.complemento || usuarioEndereco.complemento.length === 0) {
                    NavegadorUtil.alerta(this, "Cadastro incompleto.  Favor confirmar ou informar os dados de complemento no endereço e salvar seu cadastro antes de prosseguir para o carrinho.");
                    NavegadorUtil.redirect("/cadastre-se?returnUrl=/carrinho", this.props.history);
                  }

                  const enderecoCompleto: string = `${usuarioEndereco.endereco} - ${usuarioEndereco.numero} - ${usuarioEndereco.bairro} - ${usuarioEndereco.cidadeEstado}`;

                  const localizacao: LocalizacaoModel = await ProxyDistanciaDAO.getInstance().getLocalizacao(
                    enderecoCompleto
                  );
  
                  const lojas: LojaModel[] = await C5LojaDAO.getInstance().getAll();
  
                  let lojasDistancias: LojaDistanciaModel[] = lojas.map(
                    (loja) => {
                      const distancia: number = getDistance(localizacao, loja);
  
                      return {
                        loja,
                        distancia: distancia,
                        delivery: distancia <= loja.raioAtuacao,
                      } as LojaDistanciaModel;
                    }
                  );
  
                  lojasDistancias = lojasDistancias
                    .filter((l) => l.delivery)
                    .sort(LojaDistanciaModel.sort);
  
                  if (lojasDistancias.length > 0) {
                    const lojaNaLista:
                      | LojaDistanciaModel
                      | undefined = lojasDistancias.find(
                      (l: LojaDistanciaModel) => l.loja.lojaId === loja.lojaId
                    );
                    if (!lojaNaLista && loja.raiosAtuacao.length === 0) {
                      if (AppState.getModalidadeEntregaCompra() === "delivery") {
                        if (lojasDistancias.length > 0) {
                          NavegadorUtil.alerta(
                            this,
                            `A loja selecionada não entrega no seu endereço de cadastro mas existem outras que podem te atender.`
                          );
                        } else {
                          NavegadorUtil.alerta(
                            this,
                            `Nenhuma loja realiza entrega no endereço de cadastro.  Tente utilizar outro endereço ou faça a opção de compra para retirada em qualquer loja da rede.`
                          );
                        }
                      }
                      this.setState({ carregando: false, concluido: true, fretes });
                    } else {
                      C5PagamentoDAO.getInstance()
                        .getFrete(loja.cepDelivery, carrinho)
                        .then((fretesE: C5FreteModel[]) => {
                          if (fretesE.some((f) => f.tipoEntrega === "E")) {
                            this.setState({ deliveryDisponivel: true });
                          }
                          fretes = fretes.concat(
                            fretesE.filter((f) => f.tipoEntrega === "E")
                          );
                          this.setState({ carregando: false, concluido: true, fretes });
                        })
                        .catch(() => {
                          this.setState({ carregando: false, concluido: true, fretes });
                        });
                    }
                  } else {
                    LogUtil.log("delivery fora do range da loja !");
                    this.setState({ carregando: false, concluido: true, fretes });
                  }
                } else {
                  NavegadorUtil.alerta(this, "Cadastro incompleto.  Favor confirmar ou informar os dados de endereço e salvar seu cadastro antes de prosseguir para o carrinho.");
                  NavegadorUtil.redirect("/cadastre-se?returnUrl=/carrinho", this.props.history);
                }
              }
            })
            .catch(() => {
              this.setState({ carregando: false, concluido: true });
            });
        }).catch((err) => {
          this.setState({ carregando: false, concluido: true });
          NavegadorUtil.alerta(this, `Erro ao carregar conteúdo [${JSON.stringify(err)}]`);
        });
        await this.updatePromocao();
    } else {
      NavegadorUtil.redirect("/lojas", this.props.history);
    }
  }

  async componentDidUpdate(): Promise<void> {
    await this.updatePromocao();
  }

  async setRetirada(): Promise<void> {
    const usuarioLogado = AppState.getUsuarioLogado();
    if (usuarioLogado) {

      const { fretes } = this.state;
      const carrinho: CarrinhoModel = AppState.getCarrinho();
      const usuario: UsuarioModel | null = AppState.getUsuarioLogado();
      const loja: LojaModel | null = AppState.getLojaSelecionada();
      const frete: C5FreteModel | undefined = fretes.find(
        (f) => f.tipoEntrega === "R"
      );

      let possuiProdutoMaior: boolean = false;
      
      for (const ci of carrinho.carrinhoItens) {
        if (await ProdutoModel.requerMaioridade(ci.produto)) {
          possuiProdutoMaior = true;
          break;
        }
      }

      if (possuiProdutoMaior) {
        if (DataUtil.getIdade(usuarioLogado.nascimento) < 18) {
          NavegadorUtil.alerta(this, "Existem produtos no carrinho com a necessidade de confirmação de maioridade. (idade de cadastro menor que 18 anos completos).");
          return;
        } else {
          if (AppState.getMaioridade() !== true) {
            NavegadorUtil.alerta(this, "Existem produtos no carrinho com a necessidade de confirmação de maioridade.");
            return;
          }
        }
      }

      this.setState({ carregando: true });

      if (usuario && loja && frete) {
        C5PagamentoDAO.getInstance()
          .postFrete(loja, frete.freteTipoId, carrinho, usuario)
          .then(() => {
            AppState.setMetodoEntrega("retirada");
            AppState.setFreteTipoId(frete.freteTipoId);
            this.setState({ carregando: false, concluido: true });
            this.toggleModalProdutoAlternativo();
          }).catch((ex) => {
            this.setState({ carregando: false, concluido: true });
          });
      }
    } else {
      const carrinho: CarrinhoModel = AppState.getCarrinho();
      let possuiProdutoMaior = false;
      
      for (const ci of carrinho.carrinhoItens) {
        if (await ProdutoModel.requerMaioridade(ci.produto)) {
          possuiProdutoMaior = true;
          break;
        }
      }

      if (AppState.getMaioridade() !== true && possuiProdutoMaior) {
        NavegadorUtil.alerta(this, "Existem produtos no carrinho com a necessidade de confirmação de maioridade.");
        return;
      }

      NavegadorUtil.redirect("/login?returnUrl=/carrinho", this.props.history);
    }
  }

  async setDelivery(): Promise<void> {
    const usuarioLogado = AppState.getUsuarioLogado();
    if (usuarioLogado) {
      let { fretes } = this.state;
      const carrinho: CarrinhoModel = AppState.getCarrinho();
      const loja: LojaModel | null = AppState.getLojaSelecionada();
      const frete: C5FreteModel | undefined = fretes.find(
        (f) => f.tipoEntrega === "E"
      );

      let requerMaioridade = false;

      for (const ci of carrinho.carrinhoItens) {
        if (await ProdutoModel.requerMaioridade(ci.produto)) {
          requerMaioridade = true;
          break;
        }
      }
      
      if (requerMaioridade && AppState.getMaioridade() !== true) {
        
        if (DataUtil.getIdade(usuarioLogado.nascimento) < 18) {
          NavegadorUtil.alerta(this, "Existem produtos no carrinho com a necessidade de confirmação de maioridade. (idade de cadastro menor que 18 anos completos).");
          return;
        } else {
          NavegadorUtil.alerta(this, this.msgCarrinhoNecessidadeMaioridade);
          return;
        }
      }

      const whitelists = await ProxyCacheDAO.getInstance().getWhitelists(usuarioLogado);

      if (whitelists.length === 0) {
        let subtotal: number = 0;
        for (const item of carrinho.carrinhoItens) {
          if (item.produto && item.produto.unidade === "GR") {
            subtotal +=
              ((item.quantidade * item.produto.precoDesconto) / 1000) *
              item.produto.fatorMultiplicacao;
          } else {
            subtotal += item.quantidade * item.produto.precoDesconto;
          }
        }
        
        if (usuarioLogado && loja && loja.raiosAtuacao && loja.raiosAtuacao.length > 0) {
          const endereco: UsuarioEnderecoModel | null = await C5UsuarioDAO.getInstance().buscaUsuarioEnderecoCompleto(+usuarioLogado.clienteId);

          if (endereco) {
            const r = await C5UsuarioDAO.getInstance().buscaCep(endereco.cep.toString());

            const enderecoCompleto: string = `${r.StreetAddress} - ${r.Neighborhood} - ${r.City} - ${r.State}`;

            const localizacao: LocalizacaoModel = await ProxyDistanciaDAO.getInstance().getLocalizacao(
              enderecoCompleto
            );

            const distancia: number = getDistance(localizacao, loja);
            
            // let menorValor = 0;
            let maiorValor = 0;
            let menorDistancia = 0;
            let maiorDistancia = 0;

            for (const raioAtuacao of loja.raiosAtuacao) {
              // menorValor = maiorValor;
              maiorValor = raioAtuacao.ValorMinimo;

              menorDistancia = maiorDistancia;
              maiorDistancia = raioAtuacao.Distancia;

              if (distancia > menorDistancia && distancia < maiorDistancia) {
                if (subtotal < maiorValor) {
                  NavegadorUtil.alerta(
                    this,
                    `O valor mínimo de pedido no delivery desta loja em seu endereço é de R$ ${raioAtuacao.ValorMinimo},00.`
                  );
                  return;
                }
              }
            }

            if (distancia > maiorDistancia) {
              NavegadorUtil.alerta(
                this,
                `A loja selecionada não atende seu endereço de cadastro para delivery.`
              );
              return;
            }
          }
        } else {
          if (subtotal < 150) {
            NavegadorUtil.alerta(
              this,
              "O valor mínimo de pedido no delivery é de R$ 150,00."
            );
            return;
          }
        }
      } else {
        LogUtil.log("Cliente whitelist !");
      }

      this.setState({ carregando: true });

      if (usuarioLogado && loja && frete) {
        C5PagamentoDAO.getInstance()
          .postFrete(loja, frete.freteTipoId, carrinho, usuarioLogado)
          .then(() => {
            AppState.setMetodoEntrega("delivery");
            AppState.setFreteTipoId(frete.freteTipoId);
            this.setState({ carregando: false, concluido: true });
            this.toggleModalProdutoAlternativo();
          });
      }
    } else {
      const carrinho: CarrinhoModel = AppState.getCarrinho();
      let possuiProdutoMaior = false;

      for (const ci of carrinho.carrinhoItens) {
        if (await ProdutoModel.requerMaioridade(ci.produto)) {
          possuiProdutoMaior = true;
          break;
        }  
      }
      
      if (AppState.getMaioridade() !== true && possuiProdutoMaior) {
        NavegadorUtil.alerta(this, this.msgCarrinhoNecessidadeMaioridade);
        return;
      }

      NavegadorUtil.redirect("/login?returnUrl=/carrinho", this.props.history);
    }
  }

  toggleModalProdutoAlternativo(): void {
    if (AppState.getUsuarioLogado()) {
      this.setState({
        showModalProdutoAlternativo: !this.state.showModalProdutoAlternativo,
      });
    } else {
      NavegadorUtil.redirect("/login?returnUrl=/carrinho", this.props.history);
    }
  }

  hideModalExcluirCarrinho(): void {
    this.setState({
      showModalExcluirCarrinho: false,
    });
  }

  saveProdutoAlternativo(mensagem: string): void {
    AppState.setProdutoAlternativo(mensagem);
    this.setState({ carregando: true });

    const carrinho: CarrinhoModel = AppState.getCarrinho();
    if (carrinho.carrinhoItens && carrinho.carrinhoItens.length > 0) {
      const msgCarrinho = `${carrinho.carrinhoItens[0].notas ? carrinho.carrinhoItens[0].notas : ""}\r\n\r\n *** ATENÇÃO ***\r\n ${mensagem}`;
      AppState.setCarrinhoItemNota(carrinho.carrinhoItens[0].produto.produtoId, msgCarrinho);
    }

    if (AppState.getMetodoEntrega() === "retirada") {
      NavegadorUtil.redirect("/agendamento-retirada", this.props.history);
    } else {
      NavegadorUtil.redirect("/agendamento-delivery", this.props.history);
    }
  }

  goHome(): void {
    NavegadorUtil.redirect("/home", this.props.history);
  }

  alertaDeliveryInativo(): void {
    const usuario: UsuarioModel | null = AppState.getUsuarioLogado();

    if (usuario) {
      NavegadorUtil.alerta(
        this,
        `Delivery não disponível em seu CEP de entrega (${String(
          usuario.cep
        ).padStart(8, "0")})`
      );
    } else {
      NavegadorUtil.redirect("/login?returnUrl=/carrinho", this.props.history);
    }
  }

  excluirCarrinho(): void {
    this.setState({
      showModalExcluirCarrinho: true,
    });
  }

  excluirTodosProdutosCarrinho(): void {
    AppState.limparCarrinho();
    this.setState({
      showModalExcluirCarrinho: false,
    })
  }

  async updatePromocao(): Promise<void> {
    const carrinho = AppState.getCarrinho();
    const loja = AppState.getLojaSelecionada();
    let totalDescontoExtra = 0;
    if (loja) {
      ProxyPromocaoDAO.getInstance().getPromocoes(loja).then(async listaPromocoesFF => {
        for (const promo of listaPromocoesFF) {
          if (promo.de <= new Date() && promo.ate >= new Date() && promo.tipo === ObaTipoPromocaoEnum.COMPRE_X_PAGUE_Y) {
            if (promo.lojas.some(l => l.lojaId === loja.lojaId)) {
              const promoProdutos = await ProxyPromocaoDAO.getInstance().getProdutos(loja, promo.id);

              if (promoProdutos) {
                for (const carrinhoItem of carrinho.carrinhoItens) {
                  const prod = promoProdutos.find(p => p.produtoId === carrinhoItem.produto.produtoId);
                  if (prod) {
                    const qtdDescontos = Math.floor(carrinhoItem.quantidade / promo.compre);
                    totalDescontoExtra += carrinhoItem.produto.precoDesconto * qtdDescontos;
                  }
                }
                if (this.state.descontoExtra !== totalDescontoExtra) {
                  this.setState({
                    descontoExtra: totalDescontoExtra,
                  });
                }
              }
            }
          }
        }
      });
    }
  }

  render(): any {
    const { carregando, concluido, retiradaDisponivel, deliveryDisponivel, descontoExtra } = this.state;

    if (carregando) {
      return (
        <section className="lists">
          <div className="header">
            <BotaoVoltar titulo="Carregando"></BotaoVoltar>
            <Carregando exibir={carregando} concluido={concluido}></Carregando>
          </div>
        </section>
      );
    } else {
      const carrinho: CarrinhoModel = AppState.getCarrinho();
      const lojaSelecionada: LojaModel | null = AppState.getLojaSelecionada();
      const modalidade: string | null = AppState.getModalidadeEntregaCompra();

      let subtotal: number = 0,
        subtotalNormal: number = 0;
  
      let alerta: any = AppState.getAlerta();
  
      for (const item of carrinho.carrinhoItens) {
        if (item.produto && item.produto.unidade === "GR") {
          subtotal +=
            ((item.quantidade * item.produto.precoDesconto) / 1000) *
            item.produto.fatorMultiplicacao;
          subtotalNormal +=
            ((item.quantidade * item.produto.precoOriginal) / 1000) *
            item.produto.fatorMultiplicacao;
        } else {
          if (item.produto) {
            subtotal += item.quantidade * item.produto.precoDesconto;
            subtotalNormal += item.quantidade * item.produto.precoOriginal;
          }
        }
      }
  
      if (lojaSelecionada) {
        return (
          <section className="lists carrinho">
            <div className="header">
              <BotaoVoltar titulo="Carrinho"></BotaoVoltar>
            </div>
            {carrinho && carrinho.carrinhoItens.length === 0 && (
              <div className="empty-cart">
                <p className="title">Ops!</p>
                <p>
                  Nenhum item no carrinho <br /> no momento. <br />
                </p>
                <Link to={NavegadorUtil.getUrl("/home")}>Voltar às compras</Link>
              </div>
            )}
            {carrinho && carrinho.carrinhoItens.length > 0 && (
              <>
                <div className="store">
                  <p>
                    Preços da loja <span>{lojaSelecionada.nome}</span>
                  </p>
                  <Link to={NavegadorUtil.getUrl("/lojas?returnUrl=/carrinho")}>
                    Alterar
                  </Link>
                </div>
                <div>
                  <p onClick={ this.excluirCarrinho } style={{ textAlign: "right", color: "#41873f", marginRight: "20px", padding: "20px" }}>
                    Excluir todos os produtos 
                  </p>
                </div>
                <ul className="items">
                  {carrinho.carrinhoItens.map((item: CarrinhoItemModel) => (
                    <CarrinhoItem
                      item={item}
                      key={item.carrinhoItemId}
                      parent={this}
                    ></CarrinhoItem>
                  ))}
                </ul>
                <div className="total">
                  <p className="subtotal">
                    Subtotal
                    <span>{`R$ ${subtotalNormal
                      .toFixed(2)
                      .replace(".", ",")}`}</span>
                  </p>
                  <p className="discount">
                    Desconto
                    <span>{`R$ ${(subtotalNormal - subtotal + descontoExtra)
                      .toFixed(2)
                      .replace(".", ",")}`}</span>
                  </p>
                  <p className="total">
                    Total
                    <span>{`R$ ${(subtotal - descontoExtra).toFixed(2).replace(".", ",")}`}</span>
                  </p>
                </div>
                <button onClick={this.goHome} className="main-button sec">
                  Continuar comprando
                </button>
                
                { ((modalidade === 'delivery') || !modalidade) &&
                <>
                  {deliveryDisponivel && (
                    <button onClick={this.setDelivery} className="main-button">
                      receber meu pedido
                    </button>
                  )}
                  {!deliveryDisponivel && (
                    <button
                      onClick={this.alertaDeliveryInativo}
                      className="main-button"
                    >
                      receber meu pedido
                    </button>
                  )}
                </>
                }

                { modalidade && (modalidade === 'retirada') &&
                <>
                  {retiradaDisponivel && (
                    <button onClick={this.setRetirada} className="main-button">
                      retirar na loja
                    </button>
                  )}
                </>
                }

                <ModalProdutoAlternativo
                  visivel={this.state.showModalProdutoAlternativo}
                  save={this.saveProdutoAlternativo}
                  hide={this.toggleModalProdutoAlternativo}
                ></ModalProdutoAlternativo>
                <ModalExclusaoCarrinho
                  visivel={this.state.showModalExcluirCarrinho}
                  deleteAll={this.excluirTodosProdutosCarrinho}
                  hide={this.hideModalExcluirCarrinho}
                ></ModalExclusaoCarrinho>
              </>
            )}
            {alerta && (
              <Snackbar
                open={alerta.exibirModal}
                className="info"
                transitionDuration={1000}
                onClose={() => AppState.fecharAlerta(this)}
                autoHideDuration={6000}
                ContentProps={{
                  "aria-describedby": "message-id",
                }}
                message={<span id="message-id">{alerta.mensagem}</span>}
              />
            )}
            <Rodape parent={this} ativo="Carrinho"></Rodape>
            <Carregando exibir={carregando} concluido={concluido}></Carregando>
          </section>
        );
      }
    }
  }
}

export default withRouter(Carrinho);
